/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ site: NonNullable<unknown> }} Practice_Session_Mic_Blocked_Safari_MenuInputs */



/**
* | output |
* | --- |
* | "Settings for {site}…" |
*
* @param {Practice_Session_Mic_Blocked_Safari_MenuInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const practice_session_mic_blocked_safari_menu = /** @type {((inputs: Practice_Session_Mic_Blocked_Safari_MenuInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Practice_Session_Mic_Blocked_Safari_MenuInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ (`Instellingen voor ${i?.site}…`)
	if (locale === "fr") return /** @type {LocalizedString} */ (`Réglages pour ${i?.site}…`)
	return /** @type {LocalizedString} */ (`Settings for ${i?.site}…`)
});